import {IRange} from "@pg-design/inputs-module";

import {priceToForIndexation} from "../../../offer/helpers/seo/price_indexation";
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const price: ISearchFilterSlot<"price", IRange<string>> = {
    id: "price",
    label: "Cena",
    filters: [
        {
            id: "price",
            type: SearchFilterTypes.RANGE,
            filterOptions: priceToForIndexation.map((price) => ({
                id: `${price}`,
                value: `${price}`,
                label: `${price}`
            }))
        }
    ]
};
import {IRange} from "@pg-design/inputs-module";

import {priceToForIndexation} from "../../../offer/helpers/seo/price_indexation";
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const price: ISearchFilterSlot<"price", IRange<string>> = {
    id: "price",
    label: "Cena",
    filters: [
        {
            id: "price",
            type: SearchFilterTypes.RANGE,
            filterOptions: priceToForIndexation.map((price) => ({
                id: `${price}`,
                value: `${price}`,
                label: `${price}`
            }))
        }
    ]
};
